import type { MapLocation, MapViewport } from './types';
import { PLACED_MARKER_ZOOM } from './constants';

export function isPointerOverElement(
  element: Element | null | undefined,
  clientX: number,
  clientY: number,
  padding = 0,
): boolean {
  if (!element) {
    return false;
  }

  const rect = element.getBoundingClientRect();
  return (
    clientX >= rect.left - padding &&
    clientX <= rect.right + padding &&
    clientY >= rect.top - padding &&
    clientY <= rect.bottom + padding
  );
}

export function getResolvedHint({
  hintText,
  readOnly,
  showSearch,
}: {
  hintText?: string;
  readOnly: boolean;
  showSearch: boolean;
}): string {
  if (hintText) {
    return hintText;
  }

  if (readOnly) {
    return 'Location preview.';
  }

  if (showSearch) {
    return 'Search for a place, drag the pin onto the map, or drag it back to the tray to clear.';
  }

  return 'Drag the pin onto the map to set the location, or drag it back to the tray to clear.';
}

export function getMarkerPlacementViewport(
  justPlaced: boolean,
  markerCenter: google.maps.LatLngLiteral,
  currentViewport: MapViewport,
): MapViewport {
  if (justPlaced) {
    return { center: markerCenter, zoom: PLACED_MARKER_ZOOM };
  }

  return { ...currentViewport, center: markerCenter };
}

export function createClearedLocation(
  location: MapLocation | null | undefined,
): MapLocation {
  return {
    ...(location ?? {}),
    latitude: undefined,
    longitude: undefined,
    streetAddress: undefined,
    city: undefined,
    state: undefined,
    zipcode: undefined,
    formattedAddress: undefined,
    locationName: undefined,
  };
}

export function viewportFromMap(map: google.maps.Map): MapViewport | null {
  const centerLatLng = map.getCenter();
  const zoom = map.getZoom();

  if (!centerLatLng || zoom == null) {
    return null;
  }

  return {
    center: { lat: centerLatLng.lat(), lng: centerLatLng.lng() },
    zoom,
  };
}
